module.exports = __webpack_public_path__ + "img/firstkk.238811c1.jpg";